import React, { useState } from 'react';
import Button from '../../composants/Button/Button';
import { useAuth } from '../../contexts/AuthContext';
import { isPrestataireRole } from '../../utils/roleUtils';
import './CreationComptesModal.css';

const lotsDisponibles = [
  { id: '201', name: "Lot 201 - AMO" },
  { id: '202', name: "Lot 202 - MOE" },
  { id: '203', name: "Lot 203 - Urbanisme" },
  { id: '204', name: "Lot 204 - VRD" }
];

const CreationComptesModal = ({ isOpen, onClose, onCreate }) => {
  const { user } = useAuth();
  const isPrestataire = user ? isPrestataireRole(user.role) : false;

  const [form, setForm] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    fonction: '',
    role: '',
  });
  const [lots, setLots] = useState(lotsDisponibles.map(lot => ({ ...lot, isActive: false })));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleToggleLot = (lotId: string) => {
    setLots(lots.map(lot =>
      lot.id === lotId ? { ...lot, isActive: !lot.isActive } : lot
    ));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const lotsValides = lots.filter(lot => lot.isActive).map(lot => lot.id);
    onCreate({ ...form, lots: lotsValides });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay creation-comptes">
      <div className="modal">
        <h3>Créer un utilisateur</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nom*</label>
            <input type="text" name="nom" value={form.nom} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Prénom*</label>
            <input type="text" name="prenom" value={form.prenom} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Email*</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Téléphone*</label>
            <input type="tel" name="telephone" value={form.telephone} onChange={handleChange} required placeholder="0612345678" />
          </div>
          <div className="form-group">
            <label>Fonction</label>
            <input type="text" name="fonction" value={form.fonction} onChange={handleChange} placeholder="Ex: Acheteur public" />
          </div>
          <div className="form-group">
            <label>Rôle*</label>
            <select name="role" value={form.role} onChange={handleChange} required>
              <option value="">Sélectionner un rôle</option>
              {isPrestataire ? (
                // Options pour les prestataires
                <>
                  <option value="prestataire">Prestataire</option>
                  <option value="prestataire_signataire">Prestataire signataire</option>
                </>
              ) : (
                // Options pour les acheteurs
                <>
                  <option value="acheteur">Acheteur</option>
                  <option value="acheteur_signataire">Acheteur signataire</option>
                  <option value="observateur" disabled style={{ color: '#999' }}>
                    Observateur, En cours de développement
                  </option>
                </>
              )}
            </select>
          </div>
          <p className="info-text" style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>
            * Un mot de passe aléatoire sera généré et envoyé par email à l'utilisateur. Il devra le changer lors de sa première connexion.
          </p>
          {/* Afficher les droits de lot uniquement pour les validateurs acheteurs */}
          {!isPrestataire && form.role === 'validateur' && (
            <div className="form-group">
              <label>Droits de lot à valider</label>
              <div className="lots-list">
                {lots.map(lot => (
                  <div key={lot.id} className="lot-item">
                    <label className="switch-label">
                      <span>{lot.name}</span>
                      <div className="switch">
                        <input
                          type="checkbox"
                          checked={lot.isActive}
                          onChange={() => handleToggleLot(lot.id)}
                        />
                        <span className="slider"></span>
                      </div>
                    </label>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="action-buttons">
            <Button
              value="Annuler"
              variant="secondary"
              size="small"
              onClick={onClose}
            />
            <Button
              value="Créer"
              variant="primary"
              size="small"
              type="submit"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreationComptesModal;